import { ChangeDetectionStrategy, Component, inject } from '@angular/core';
import { ImagesService } from '../shared/image-service';

@Component({
  selector: 'app-maintenance',
  templateUrl: './maintenance.component.html',
  styleUrls: ['./maintenance.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false
})
export class MaintenanceComponent {
  
  
  activeTab = 0;

  tabs: string[] = ['Images', 'Icons'];
  
  // menu selector
  setActiveTab(index: number): void {
    this.activeTab = index;
  }

}
